<template>
    <v-container
            fill-height
            fluid
            grid-list-xl>
        <v-layout wrap>
            <v-flex sm6
                    xs12
                    md6
                    lg4>
                <material-stats-card
                        color="orange"
                        icon="mdi-help-box"
                        title="Name"
                        :value="survey.name"/>
            </v-flex>
            <v-flex sm6
                    xs12
                    md6
                    lg4>
                <material-stats-card
                        color="green"
                        icon="mdi-account"
                        title="Owner"
                        :value="survey.owner"/>
            </v-flex>
            <v-flex sm6
                    xs12
                    md6
                    lg4>
                <material-stats-card
                        color="red"
                        icon="mdi-account-question"
                        title="Type"
                        :value="survey.type"/>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <material-card class="card-tabs" color="green" title="List Question">
                    <v-list three-line>
                        <v-list-tile v-for="question in survey.questions" v-bind:key="question.id"
                                     :to="'/question-report/' + survey.token +'/'+ question.id">
                            <v-list-tile-action>
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="primary"
                                           icon>
                                        <v-icon color="accent">mdi-help-circle</v-icon>
                                    </v-btn>
                                    <span>{{question.content}}</span>
                                </v-tooltip>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                {{question.content}}
                            </v-list-tile-title>
                            <div class="d-flex">
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="success"
                                           icon
                                           :to="'/question-report/' + survey.token +'/'+ question.id">
                                        <v-icon color="primary">mdi-information</v-icon>
                                    </v-btn>
                                    <span>Details</span>
                                </v-tooltip>
                            </div>
                        </v-list-tile>
                    </v-list>
                </material-card>
            </v-flex>
            <v-flex xs12 sm12 md12 v-if="survey.type==='Quiz'">
                <material-card
                        color="green"
                        title="Results">
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-text-field
                                :append-icon="search?'mdi-close':'mdi-magnify'"
                                :append-icon-cb="() => (search = '')"
                                @keydown.native.escape="search=''"
                                class="mr-4 mt-2 purple-input"
                                label="Search..."
                                hide-details
                                color="purple"
                                style="flex-grow: 0 !important;"
                                v-model="search"/>
                    </div>
                    <v-data-table
                            :headers="headers"
                            :items="user_choices"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :total-items="totalUserChoices">
                        <template v-slot:items="props">
                            <td class="text-xs-center">{{ props.item.sender_id }}</td>
                            <td class="text-xs-center">{{ props.item.true_count }}</td>
                            <td class="text-xs-center">{{ props.item.total_question}}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                No data available
                            </v-alert>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                :color="snackbar.color"
                bottom
                right
                v-model="snackbar.show"
                dark>
            <v-icon color="white"
                    class="mr-3">
                {{snackbar.icon}}
            </v-icon>
            <div>{{snackbar.message}}</div>
            <v-icon size="16"
                    @click="snackbar.show = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-container>
</template>
<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                search: '',
                totalUserChoices: 0,
                user_choices: [],
                loading: true,
                pagination: {},
                rowsPerPageItems: [5, 10, 20, 50, 100],
                survey: {},
                questions: [],
                //Notify
                snackbar: {
                    color: '',
                    message: '',
                    show: false,
                    icon: ''
                },
                headers: [
                    {
                        text: 'Sender ID',
                        align: 'center',
                        sortable: false,
                        value: 'sender_id'
                    },
                    {
                        text: 'Total True Choice',
                        align: 'center',
                        value: 'true_count',
                        sortable: false
                    },
                    {
                        text: 'Total Question',
                        align: 'center',
                        sortable: false,
                        value: 'total_question'
                    },
                ],
            }
        },
        computed: {
            params(v) {
                return {
                    ...this.pagination,
                    query: this.search
                };
            }
        },
        watch: {
            params: {
                handler() {
                    let self = this
                    self.getResultsByPagination(self.$route.params['id'], self.search, self.pagination.page, self.pagination.rowsPerPage)
                        .then((user_choices) => {
                            self.user_choices = user_choices.data.results
                            self.totalUserChoices = user_choices.data.total
                        })
                },
            }
        },
        created() {
            let self = this
            self.fetchData()
        },
        methods: {
            //Notify
            showSuccessNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'success',
                    message: message,
                    show: true,
                    icon: 'mdi-information-variant'
                }
            },
            showErrorNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'error',
                    message: message,
                    show: true,
                    icon: 'mdi-alert-circle-outline'
                }
            },
            async getSurveyByToken(token) {
                return await axios.get('/api/survey/' + token + '/', {withCredentials: true})
            },
            async getResultsByPagination(token, search, page, page_size) {
                let url = '/api/quiz-result?data=true'
                if (search)
                    url = url + '&search=' + search
                if (page)
                    url = url + '&page=' + page
                if (page_size)
                    url = url + '&page_size=' + page_size
                return await axios.get(url, {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                })
            },
            fetchData() {
                let self = this
                self.getSurveyByToken(self.$route.params['id'])
                    .then((survey) => {
                        self.survey = survey.data
                        return survey.data.questions
                    }).then(() => self.getResultsByPagination(self.$route.params['id'], self.search, self.pagination.page, self.pagination.rowsPerPage))
                    .then((user_choices)=>{
                        self.user_choices = user_choices.data.results
                        self.totalUserChoices = user_choices.data.total
                })
                    .catch((error) => self.showErrorNotify('Have some error:' + error))
            }
        }
    }
</script>

<style lang="scss">

</style>